export default {
  labels: {
    invoice: 'Fattura',
    on_site: 'Paga in loco (Contanti/Carta)',
  },
};
